import di from '@jsmodules/di';

// import { RxDbKeyValueStorage } from '@jsmodules/storage/dist/rxdb';

// di.Register("kvStorage", "Request").class(RxDbKeyValueStorage);

export default di;
